import type { Sale } from "../models/Sale";
import { actionStatus } from "./ReturnMath";
export const saleReturnCredit=(sale:Sale)=>sale.Items.flatMap(l=>l.ReturnHistories??[]).filter(h=>actionStatus(h.Status)==="Approve").reduce((s,h)=>s+Number(h.Amount||0),0);
export const netSaleTotal=(sale:Sale)=>Math.max(0,sale.TotalAmount-saleReturnCredit(sale));
export const saleBalance=(sale:Sale)=>Math.max(0,netSaleTotal(sale)-Math.max(0,sale.AmountPaid));
